module.exports = __webpack_public_path__ + "media/newstyle/images/book-upload-icon-694209eee377b416d2f15dedb7063f54.svg";